import type { DefaultAssignee } from '../../common/model/types.tsx';
import { createOptions } from '../../common/rest/index.tsx';

export type CreateRequestPayload = {
	name: string;
	description: string | undefined;
	leadAccountId?: string | undefined;
	assigneeType: DefaultAssignee;
	project: string;
	projectId: number;
};

export const getUrl = (baseUrl: string) => `${baseUrl}/rest/api/2/component`;

export const create = (baseUrl: string, payload: CreateRequestPayload): Promise<Response> =>
	fetch(getUrl(baseUrl), createOptions('POST', payload));
